import React from 'react';
import { Row, Col } from 'antd';
import { BInput } from 'common/components';

const SignerBASF = ({ fullName, position, numSignerBASF }) => {
  return (
    <>
      {[1, 2, 3, 4].map((d) => {
        return (
          <Row key={d}>
            <Col span={8}>
              <BInput
                className="form-add-user-input"
                placeholder="Escribe nombre"
                maxLength={100}
                name={`fullName${d}`}
                label={d < 3 ? '*Nombre completo del firmante:' : 'Nombre completo del firmante:'}
              />
            </Col>

            <Col span={8}>
              <BInput
                className="form-add-user-input"
                maxLength={100}
                placeholder="Escribe posición"
                name={`position${d}`}
                label={d < 3 ? '*Posición:' : 'Posición:'}
              />
            </Col>
          </Row>
        );
      })}
    </>
  );
};

export default SignerBASF;
